import React from "react";
import { DownloadCsvButton } from "../../../components/download/DownloadCsvButton.js";
import "../../../components/download/DownloadTemplate.js";
import { useUserProfileDownload } from "../hooks.js";
function UserProfileDownloadCsvButton(props) {
  const { handleDownload, isProgress } = useUserProfileDownload(props);
  return /* @__PURE__ */ React.createElement(DownloadCsvButton, { onClick: handleDownload, loading: isProgress, disabled: isProgress || props.total === 0 });
}
export {
  UserProfileDownloadCsvButton
};
//# sourceMappingURL=DownloadCsvButton.js.map
